<ng-container *transloco="let t; prefix: 'dashboard-share-dialog'">
    <mat-dialog-content>
        <div class="content-wrapper">
            <div class="section">
                <h3 class="section-title">{{ t('current-shares') }}</h3>
                @if (!loading && currentShares.length > 0) {
                    <table
                        mat-table
                        [dataSource]="currentShares"
                        class="mat-elevation-z1"
                    >
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ t('type') }}
                            </th>
                            <td mat-cell *matCellDef="let share">
                                {{ getShareTypeLabel(share) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="target">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ t('share-target') }}
                            </th>
                            <td mat-cell *matCellDef="let share">
                                <span class="font-semibold">{{
                                    getShareTargetLabel(share)
                                }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="permissions">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ t('permissions') }}
                            </th>
                            <td mat-cell *matCellDef="let share">
                                <div
                                    class="flex gap-2 bg-gray-50 icon-size-5"
                                    [matTooltip]="
                                        getSharePermissionLabel(share)
                                    "
                                >
                                    <mat-icon
                                        svgIcon="heroicons_solid:pencil-square"
                                        [class.text-green-500]="share.canEdit"
                                        [class.text-gray-300]="!share.canEdit"
                                    />
                                    <mat-icon
                                        svgIcon="heroicons_solid:share"
                                        [class.text-green-500]="share.canShare"
                                        [class.text-gray-300]="!share.canShare"
                                    />
                                    <mat-icon
                                        svgIcon="heroicons_solid:trash"
                                        [class.text-green-500]="share.canDelete"
                                        [class.text-gray-300]="!share.canDelete"
                                    />
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let share">
                                <div class="flex w-full justify-end">
                                    <button
                                        mat-icon-button
                                        (click)="onRemoveShare(share)"
                                        matTooltip="{{ t('remove') }}"
                                        class="hover:bg-red-100"
                                    >
                                        <mat-icon class="icon-size-5"
                                            >delete</mat-icon
                                        >
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <!-- <tr mat-header-row *matHeaderRowDef="['type', 'target', 'permissions', 'actions']"></tr> -->
                        <tr
                            mat-row
                            *matRowDef="
                                let row;
                                columns: [
                                    'type',
                                    'target',
                                    'permissions',
                                    'actions',
                                ]
                            "
                        ></tr>
                    </table>
                }

                @if (loading) {
                    <div class="loading-container">
                        <mat-progress-spinner
                            diameter="36"
                            mode="indeterminate"
                        />
                    </div>
                }

                <!-- <mat-list *ngIf="!loading && currentShares.length > 0">
        <mat-list-item *ngFor="let share of currentShares">
          <div matListItemTitle>{{ getShareTargetLabel(share) }}</div>
          <div matListItemLine>{{ getSharePermissionLabel(share) }}</div>
        </mat-list-item>
      </mat-list> -->

                @if (!loading && currentShares.length === 0) {
                    <p class="empty-state">
                        {{ t('no-shares') }}
                    </p>
                }
            </div>

            <!-- <mat-divider></mat-divider> -->

            <div class="section">
                <h3 class="section-title">{{ t('new-share') }}</h3>

                <form
                    id="dashboardShareForm"
                    [formGroup]="shareForm"
                    (ngSubmit)="onSubmit()"
                >
                    <div class="flex flex-row items-center justify-between">
                        <label class="mb-2 block">{{ t('level') }}</label>
                        <mat-radio-group
                            formControlName="level"
                            class="flex flex-row gap-2"
                        >
                            <mat-radio-button
                                [value]="DashboardShareLevel.Cibling"
                                >{{ t('levels.cibling') }}</mat-radio-button
                            >
                            <mat-radio-button
                                [value]="DashboardShareLevel.Subscribers"
                                >{{ t('levels.subscribers') }}</mat-radio-button
                            >
                            <mat-radio-button
                                [value]="DashboardShareLevel.Public"
                                >{{ t('levels.public') }}</mat-radio-button
                            >
                        </mat-radio-group>
                    </div>

                    @if (isCiblingLevel()) {
                        <div class="mb-2 flex flex-wrap gap-2">
                            @for (user of ciblingUsers(); track user) {
                                <div
                                    class="flex items-center gap-2 rounded-md bg-blue-100 px-2 shadow-md"
                                >
                                    <mat-icon
                                        svgIcon="heroicons_solid:user"
                                        class="text-gray-500 icon-size-4"
                                    />
                                    <span>{{ user.fullName }}</span>
                                    <button
                                        type="button"
                                        class="my-auto h-5 hover:text-red-400"
                                        (click)="
                                            onRemoveCiblingUser($event, user.id)
                                        "
                                    >
                                        <mat-icon class="icon-size-4"
                                            >close</mat-icon
                                        >
                                    </button>
                                </div>
                            }
                            @for (
                                company of ciblingCompanies();
                                track company
                            ) {
                                <div
                                    class="flex items-center gap-2 rounded-md bg-orange-100 px-2 shadow-md"
                                >
                                    <mat-icon
                                        svgIcon="heroicons_solid:building-office"
                                        class="text-gray-500 icon-size-4"
                                    />
                                    <span>{{ company.name }}</span>
                                    <button
                                        type="button"
                                        class="my-auto h-5 hover:text-red-400"
                                        (click)="
                                            onRemoveCiblingCompany(
                                                $event,
                                                company.id
                                            )
                                        "
                                    >
                                        <mat-icon class="icon-size-4"
                                            >close</mat-icon
                                        >
                                    </button>
                                </div>
                            }
                        </div>
                    }

                    @if (isCiblingLevel()) {
                        <div class="grid grid-cols-1 gap-3">
                            <mat-form-field>
                                <mat-label>{{ t('target-search') }}</mat-label>
                                <input
                                    type="text"
                                    matInput
                                    [formControl]="shareTargetSearchControl"
                                    [matAutocomplete]="shareTargetAutocomplete"
                                    [placeholder]="t('target-search-hint')"
                                />
                                <mat-autocomplete
                                    #shareTargetAutocomplete="matAutocomplete"
                                    [displayWith]="displayShareTarget"
                                    (optionSelected)="
                                        onShareTargetOptionSelected(
                                            $event.option.value
                                        )
                                    "
                                >
                                    @for (
                                        option of getFilteredShareTargets();
                                        track option
                                    ) {
                                        <mat-option
                                            [value]="option"
                                            (mousedown)="
                                                onShareTargetOptionMouseDown(
                                                    $event,
                                                    option
                                                )
                                            "
                                        >
                                            <div
                                                class="flex h-full w-full items-center justify-between gap-2"
                                            >
                                                <span>{{ option.label }}</span>
                                                <span
                                                    class="text-secondary text-sm"
                                                    >{{
                                                        option.secondaryLabel
                                                    }}</span
                                                >
                                            </div>
                                        </mat-option>
                                    }
                                    <!-- <mat-option *ngIf="!shareTargetSearchControl.value" disabled>
                  {{}}
                </mat-option> -->
                                    @if (
                                        shareTargetSearchControl.value &&
                                        getFilteredShareTargets().length === 0
                                    ) {
                                        <mat-option disabled>
                                            {{
                                                'common.no-results' | transloco
                                            }}
                                        </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    }

                    <div class="permissions-grid">
                        <mat-checkbox formControlName="canEdit">{{
                            t('permission-options.edit')
                        }}</mat-checkbox>
                        <mat-checkbox formControlName="canShare">{{
                            t('permission-options.share')
                        }}</mat-checkbox>
                        <mat-checkbox formControlName="canDelete">{{
                            t('permission-options.delete')
                        }}</mat-checkbox>
                    </div>

                    @if (isCiblingLevel() && !canSubmit()) {
                        <p class="validation-message">
                            {{ t('validation.target-required') }}
                        </p>
                    }
                </form>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="gap-2">
        <button type="button" mat-stroked-button (click)="onCancel()" autofocus>
            {{ 'common.close' | transloco }}
        </button>
        <button
            type="submit"
            form="dashboardShareForm"
            mat-raised-button
            color="primary"
            [disabled]="!canSubmit()"
        >
            {{ t('submit') }}
        </button>
    </mat-dialog-actions>
</ng-container>
